module.exports = __webpack_public_path__ + "static/media/diner-robot.03bcac68.jpg";